import * as React from 'react';
import * as styles from './CreditCardIcon.scss';

const subBlocks = new Array(4);

export default (props: any) => (
  <div
    className={styles.creditCardIcon}
    data-hook="wcn-credit-card-icon"
  >
    <img src="https://www.wix.com/_partials/third-party/cashier-settings/cashier-payments/creditCard.svg" />
  </div>
);



// WEBPACK FOOTER //
// ./components/icons/CreditCardIcon/CreditCardIcon.tsx